import { Text, View } from '@react-pdf/renderer'

export default function ActPdfFooter({ data, styles }) {
    return <>
        <View style={{ fontFamily: 'Times New Roman' }}>
          <Text style={styles.simpleString}>Сынама алу барысына қатысқан нысан өкiлiнiң тегi, аты, әкесiнiң аты(Должность, фамилия, имя, отчество представителя объекта, в присутствии которого произведен отбор):</Text>
          <Text style={styles.string}>Қолы(подпись) </Text>
        </View>
        <View style={{ fontFamily: 'Times New Roman', marginTop: 10 }}>
          <Text style={styles.simpleString}>Үлгілерді алған адамның лауазымы, Т.А.Ә. (болған жағдайда), (Должность, Ф.И.О. (при наличии) производившего отбор образцов): {data.responsibleForProbes?.fullName}</Text>
          <Text style={styles.string}>Қолы(подпись)</Text>
          <Text style={styles.string}>Акт составлен в экземплярах(кол-во) _____</Text>
        </View>
    </>
}